import FootnoteTooltip from '@foundryspatial/footnote-tooltip';

import ReportSection from './ReportSection.vue';

/**
 * A mixin to include common report components and props.
 */
export default {
    components: {
        FootnoteTooltip,
        ReportSection,
    },

    props: {
        reportData: {
            type: Object,
            required: true,
        },

        id: {
            type: String,
            required: true,
        },
    },
};
